import { inject, observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { InjectedCalendarStore, Trash } from "../../models/calendar";
import { ICalendarStore } from "../../models/calendar/CalendarStore";
import styles from "./trashBar.css";

export interface Props {
  calendarStore?: ICalendarStore;
}

@inject("calendarStore")
@observer
export class TrashBar extends React.Component<Props, {}> {
  get injected(): InjectedCalendarStore {
    return this.props as InjectedCalendarStore;
  }

  render() {
    const { trash, draggingMeeting } = this.injected.calendarStore;
    const classNames = [styles["trash-bar"]]
      .concat(
        trash.state === Trash.PROMPT || trash.state === Trash.UNDO || draggingMeeting
          ? [styles.visible]
          : []
      )
      .concat(trash.state === Trash.PROMPT || draggingMeeting ? [styles.prompt] : []);

    const guestDisplayName = trash.meeting && trash.meeting.guestDisplayName;
    return (
      <div
        className={styles["trash-bar-wrap"]}
        onMouseEnter={() => draggingMeeting && draggingMeeting.mouseEnteredTrashBar()}
        onMouseLeave={() => draggingMeeting && draggingMeeting.mouseLeftTrashBar()}
      >
        <div className={classNames.join(" ")}>
          {((trash.state === Trash.PROMPT || draggingMeeting) && (
            <span>
              <i className="icon-trash-dashboard" />
              <L10n id={"calendar.dropHereToDelete"} />
            </span>
          )) ||
            (trash.state === Trash.UNDO && guestDisplayName && (
              <span className={styles["deleted-container"]}>
                <span className={styles["deleted-label"]}>
                  <L10n id={"calendar.cancelledMeetingWith"} values={{ guestDisplayName }} />
                </span>
                <u className={styles["undo-link"]} onClick={() => trash.undeleteMeeting()}>
                  <L10n id={"calendar.undo"} />
                </u>
              </span>
            ))}
        </div>
      </div>
    );
  }
}
